module.exports = __webpack_public_path__ + "img/1F1EC-1F1EA.b0bb5e5d.svg";